var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMypage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 32.0018C24.836 32.0018 31.9999 24.838 31.9999 16.0009C31.9999 7.16385 24.836 0 15.999 0C7.1619 0 -0.00195312 7.16385 -0.00195312 16.0009C-0.00195312 24.838 7.1619 32.0018 15.999 32.0018Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_534_2817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 32.0018C25.337 32.0018 32.5009 24.838 32.5009 16.0009C32.5009 7.16386 25.337 0 16.4999 0C7.66288 0 0.499023 7.16386 0.499023 16.0009C0.499023 24.838 7.66288 32.0018 16.4999 32.0018Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0584 6.43599C15.3674 7.16339 16.2075 7.50258 16.9349 7.1936C17.6623 6.88461 18.0015 6.04446 17.6925 5.31707C17.3835 4.58967 16.5434 4.25048 15.816 4.55946C15.0886 4.86845 14.7494 5.7086 15.0584 6.43599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.68 8.11666C21.989 8.84405 22.8291 9.18324 23.5565 8.87426C24.2839 8.56528 24.6231 7.72513 24.3141 6.99773C24.0051 6.27034 23.165 5.93114 22.4376 6.24013C21.7102 6.54911 21.371 7.38926 21.68 8.11666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_534_2817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.499023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypage);
export default __webpack_public_path__ + "static/media/mypage.ce407394a0b4b9a2700974a507b7f00a.svg";
export { ForwardRef as ReactComponent };